<template>
  <header :class="['site-header', { 'site-header--scrolled': scrolledNav }]">
    <div class="header-inner">
      <router-link class="brand" :to="{ name: 'Home' }" @click="mobileNav = false">
        <img src="../assets/JORGE-CASTANHO-LDA-LOGOTIPO-TRANSP.png" :alt="t('nav.logoAlt')" />
      </router-link>

      <button
        class="mobile-toggle"
        type="button"
        @click="toggleMobileNav"
        :aria-expanded="String(mobileNav)"
        :aria-label="t('nav.toggleNavigation')"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav :class="['nav-links', { 'nav-links--open': mobileNav || !mobile }]">
        <router-link class="link" :to="{ name: 'Home' }" @click="mobileNav = false">{{
          t("nav.company")
        }}</router-link>
        <router-link class="link" :to="{ name: 'Portfolio' }" @click="mobileNav = false"
          >{{ t("nav.portfolio") }}</router-link
        >
        <router-link class="link" :to="{ name: 'About' }" @click="mobileNav = false">{{
          t("nav.contact")
        }}</router-link>
        <router-link class="link link--cta" :to="{ name: 'About' }" @click="mobileNav = false"
          >{{ t("nav.requestQuote") }}</router-link
        >

        <div class="language-switch" role="group" :aria-label="t('nav.languageSwitcher')">
          <button
            type="button"
            class="lang-btn"
            :class="{ 'lang-btn--active': currentLocale === 'en' }"
            :aria-label="t('nav.switchToEnglish')"
            @click="changeLocale('en')"
          >
            {{ t("nav.languageEnglish") }}
          </button>
          <button
            type="button"
            class="lang-btn"
            :class="{ 'lang-btn--active': currentLocale === 'pt' }"
            :aria-label="t('nav.switchToPortuguese')"
            @click="changeLocale('pt')"
          >
            {{ t("nav.languagePortuguese") }}
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { i18nState, setLocale, t } from "../i18n";

export default {
  name: "Navigation",
  data() {
    return {
      scrolledNav: false,
      mobile: false,
      mobileNav: false,
      windowWidth: 0,
    };
  },
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreen);
    window.removeEventListener("scroll", this.updateScroll);
  },
  computed: {
    currentLocale() {
      return i18nState.locale;
    },
  },
  methods: {
    t,
    changeLocale(locale) {
      setLocale(locale);
    },
    toggleMobileNav() {
      this.mobileNav = !this.mobileNav;
    },
    updateScroll() {
      this.scrolledNav = window.scrollY > 12;
    },
    checkScreen() {
      this.windowWidth = window.innerWidth;
      this.mobile = this.windowWidth <= 940;
      if (!this.mobile) {
        this.mobileNav = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 90;
  backdrop-filter: blur(9px);
  background: rgba(255, 255, 255, 0.87);
  border-bottom: 1px solid rgba(91, 28, 159, 0.12);
  transition: box-shadow var(--ease), background var(--ease);
}

.site-header--scrolled {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 28px rgba(15, 20, 28, 0.09);
}

.header-inner {
  width: min(calc(100% - 2.5rem), var(--content-max));
  margin-inline: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 82px;
  gap: 1rem;
}

.brand {
  display: inline-flex;
  align-items: center;
}

.brand img {
  width: min(285px, 42vw);
}

.mobile-toggle {
  display: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(91, 28, 159, 0.2);
  background: rgba(91, 28, 159, 0.06);
  padding: 0.6rem;
  cursor: pointer;
}

.mobile-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: #25143d;
  margin: 5px 0;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.language-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.4rem;
  padding-left: 0.8rem;
  border-left: 1px solid rgba(91, 28, 159, 0.15);
}

.lang-btn {
  border: 1px solid rgba(91, 28, 159, 0.2);
  background: rgba(91, 28, 159, 0.04);
  color: #2a3244;
  border-radius: 999px;
  padding: 0.45rem 0.65rem;
  min-width: 44px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: color var(--ease), background var(--ease), border-color var(--ease);
}

.lang-btn:hover {
  border-color: rgba(91, 28, 159, 0.35);
  color: var(--brand-purple);
}

.lang-btn--active {
  color: #ffffff;
  background: linear-gradient(135deg, var(--brand-purple) 0%, var(--brand-purple-deep) 100%);
  border-color: transparent;
}

.link {
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.78rem;
  font-weight: 650;
  padding: 0.7rem 1rem;
  border-radius: 999px;
  color: #2a3244;
  transition: color var(--ease), background var(--ease), transform var(--ease);
}

.link:hover,
.link.router-link-exact-active {
  background: rgba(91, 28, 159, 0.12);
  color: var(--brand-purple);
}

.link--cta {
  background: linear-gradient(135deg, var(--brand-purple) 0%, var(--brand-purple-deep) 100%);
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(47, 15, 87, 0.25);
}

.link--cta:hover,
.link--cta.router-link-exact-active {
  color: #ffffff;
  background: linear-gradient(135deg, #6a28b3 0%, #3e126f 100%);
  transform: translateY(-1px);
}

@media (max-width: 940px) {
  .mobile-toggle {
    display: block;
  }

  .nav-links {
    position: absolute;
    top: 100%;
    right: 1.25rem;
    display: none;
    width: min(86vw, 330px);
    flex-direction: column;
    align-items: stretch;
    padding: 0.85rem;
    border-radius: 18px;
    border: 1px solid rgba(91, 28, 159, 0.18);
    background: #ffffff;
    box-shadow: 0 18px 36px rgba(15, 20, 28, 0.14);
  }

  .nav-links--open {
    display: flex;
    animation: reveal 220ms ease;
  }

  .link {
    text-align: center;
  }

  .language-switch {
    margin-left: 0;
    padding-left: 0;
    border-left: 0;
    justify-content: center;
  }

  @keyframes reveal {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
